import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../../services/adminApi';
import './Admin.css';

export default function AdminLogin() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await adminLogin(password);
      navigate('/admin');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page admin-login">
      <div className="admin-card">
        <h1 className="admin-card__title">Admin Login</h1>
        <p className="admin-card__subtitle">Surveys Administration</p>
        <form onSubmit={handleSubmit} className="admin-form">
          <div className="admin-form__group">
            <label htmlFor="password" className="admin-form__label">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="admin-form__input"
              placeholder="Enter admin password"
              required
              autoFocus
            />
          </div>
          {error && <div className="admin-form__error">{error}</div>}
          <button type="submit" className="btn btn--primary admin-form__submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
